import { DefaultFetchService, NoCacheHeaders } from "app/services/fetchService";

const timeout = 60000;
/**
 * //TODO: ilan - This class NEEDS to be changed when there will be no more angular, the way it is now, with handler is incorrect, need to move to just return promise
 *
 */

interface IAppsResourceService {
    appInfo: (params, handler: (data: any) => void) => Promise<any>;
    appInfoAndRelatedInfo: (params: any) => Promise<any>;
    similarApps: (params: any) => Promise<Array<any>>;
    affinity: (params: any) => Promise<any>;
    storeOptions: () => Promise<any>;
}

export const AppsResourceService: IAppsResourceService = {
    appInfo: (params, handler) => {
        return DefaultFetchService.getInstance()
            .get<any>("/api/MobileApps/GetAppInfo", params, { headers: NoCacheHeaders, timeout })
            .then((resource) => {
                const r = {
                    data: resource,
                };
                handler && handler(r);
            });
    },
    appInfoAndRelatedInfo: async (params) => {
        const resource = await DefaultFetchService.getInstance().get<any>(
            "/api/MobileApps/GetAppInfoAndRelatedInfo",
            params,
            {
                headers: NoCacheHeaders,
                timeout,
            },
        );

        return {
            data: resource,
        };
    },

    similarApps: (params) => {
        return DefaultFetchService.getInstance().get<any>("/api/MobileApps/GetSimilarApps", params, { timeout });
    },

    affinity: (params) => {
        return DefaultFetchService.getInstance().get<any>("/api/AppEngagement/GetAudienceInterests", params, {
            timeout,
        });
    },
    storeOptions: () => {
        return DefaultFetchService.getInstance()
            .get<any>("/api/TopApps/StoreOptions", {}, { timeout })
            .then((res) => {
                return res;
            });
    },
};
